import { useState, useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { HOST_URL, reqOptions } from "../../assets/js/helpFunction";
import styled from "styled-components";
import WithAuth from "../../components/partials/withAuth";
import { SVGs } from "../../assets/svg/SVGs";
import { getEstateID, MssgContainer } from "../../components/partials/utils";
import { useCurrentLocation } from "../../utils/useLocation";
import { faTrash } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Link } from "react-router-dom";

const Security = () => {
  const [openModal, setOpenModal] = useState(false);
  const [reports, setReports] = useState([]);
  const [data, setData] = useState({});
  console.log("reports", reports);

  const addReport = (report) => {
    setReports((prev) => [...prev, report]);
  };

  const handleCloseModal = () => {
    setOpenModal(false);
  };

  return (
    <WithAuth>
      {/* {mssg.mssg && <MssgContainer mssg={mssg} close={closeMssg} />} */}
      <div>
        <button className="important-btn" onClick={() => setOpenModal(true)}>
          Create Report
        </button>
      </div>
      <UtilityGrid>
        <div className="Utility_table">
          {reports.length ? (
            reports.map((report, index) => (
              <Designation key={index} report={report} />
            ))
          ) : (
            <p>
              No patrol report created at the moment.{" "}
              <a
                onClick={() => setOpenModal(true)}
                style={{
                  cursor: "pointer",
                  color: "#2D4BF3",
                  fontWeight: "bolder",
                }}
              >
                Create one
              </a>
            </p>
          )}
        </div>
      </UtilityGrid>
      <ReportModal
        designations={[]}
        open={openModal}
        onClose={handleCloseModal}
        addReport={addReport}
      />
    </WithAuth>
  );
};

export default Security;

const Designation = ({ report }) => {
  const navigate = useNavigate();

  const [openModal, setOpenModal] = useState(false);

  const addReport = (report) => {
    // setReports((prev) => [...prev, report]);
  };

  const handleCloseModal = () => {
    setOpenModal(false);
  };

  return (
    <>
      <div className="utils">
        <div className="util-payment">
          <div className="name_tag">
            <h4>{report.name}</h4>
            <button>{report.name}</button>
          </div>

          <div className="util-acct">
            <p>
              Name: <b>{report.name}</b>
            </p>

            <p>
              Designation: <b>{report.designation}</b>
            </p>
            <div className="price">
              <p>
                {/* QuestionType:{" "} */}
                <b>{/* {report.lowerTime} - {report.higherTime} */}</b>
              </p>
            </div>
          </div>
          <div style={{ marginTop: "15px" }}>
            <span
              className="edit-btn util-btn"
              onClick={() => setOpenModal(true)}
            >
              Edit
            </span>
            <span
              className="del-btn util-btn"
              // onClick={() => deleteUtility(report.id)}
            >
              Delete
            </span>
            <span
              style={{ float: "right" }}
              className="edit-btn util-btn"
              // onClick={() => navigate("/report-responses")}
            >
              <Link to={`/report-responses`}>View responses</Link>
            </span>
          </div>
        </div>
      </div>

      <ReportModal
        designations={[]}
        open={openModal}
        onClose={handleCloseModal}
        addReport={addReport}
      />
    </>
  );
};

const ReportModal = ({ open, onClose, addReport, edit_data }) => {
  // const data = edit_data
  const default_utility = {
    name: "",
    designation: "",
    form: [],
  };
  const [report, setReport] = useState(default_utility);
  const [currentField, setCurrentField] = useState("");
  const [currentFieldType, setCurrentFieldType] = useState("");
  const [currentOption, setCurrentOption] = useState("");
  const [currentOptions, setCurrentOptions] = useState([]);
  const designations = ["Car park", "Mall", "Main gate"];

  if (!open) return null;
  const handleChange = (e) => {
    const { name, value } = e.target;
    setReport({ ...report, [name]: value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    let add_data = report;
    addReport(add_data);
    setReport(default_utility);
    onClose(false);
  };
  const isValid = report.name && report.designation;

  const handleDelete = (formPassed) => {
    const newForm = report.form?.filter(
      (form) => form.fieldName !== formPassed?.fieldName,
    );
    setReport((report) => ({ ...report, form: newForm }));
  };

  return (
    <div onClick={onClose} className="bills_on_me">
      <div
        onClick={(e) => {
          e.stopPropagation();
        }}
        className="modalContainer"
        style={{
          maxWidth: "60vw",
          width: "60vw",
          marginRight: "auto",
          marginLeft: "auto",
        }}
      >
        <div
          className="new_estates_form fade-in-bck"
          style={{
            maxWidth: "60vw",
            width: "60vw",
            marginRight: "auto",
            marginLeft: "auto",
          }}
        >
          <div className="form-group">
            <div className="create_est ">
              <div className="form_txt">
                <h3>Enter details for report form</h3>
              </div>
              <input
                type="text"
                value={report.name}
                name="name"
                placeholder="Name"
                onChange={handleChange}
              />

              <select
                onChange={(e) => {
                  setReport((report) => ({
                    ...report,
                    designation: e.target.value,
                  }));
                }}
                value={report.designation}
                className="form-control"
                placeholder="Report Designation"
              >
                <option value="">Select Report Designation</option>
                {designations.map((designation) => (
                  <option key={designation} value={designation}>
                    {designation}
                  </option>
                ))}
              </select>

              <div style={{ marginTop: "50px" }}>
                <h4 style={{ marginTop: "20px" }}>Form questionnaire</h4>

                {!!report.form?.length && (
                  <div>
                    <div
                      style={{
                        display: "flex",
                        alignItems: "flex-start",
                        gap: "40px",
                        justifyContent: "space-between",
                        marginBottom: "20px",
                      }}
                    >
                      <p
                        style={{
                          fontWeight: 600,
                          fontSize: "19px",
                          width: "30%",
                        }}
                      >
                        Form Question
                      </p>
                      <p
                        style={{
                          fontWeight: 600,
                          fontSize: "19px",
                          width: "30%",
                        }}
                      >
                        Question Type
                      </p>
                      <p
                        style={{
                          fontWeight: 600,
                          fontSize: "19px",
                          width: "30%",
                        }}
                      >
                        Options
                      </p>
                    </div>
                    {report.form?.map((formValue) => (
                      <div
                        style={{
                          display: "flex",
                          alignItems: "flex-start",
                          gap: "40px",
                          justifyContent: "space-between",
                          marginBottom: "20px",
                        }}
                      >
                        <p
                          style={{
                            fontWeight: 500,
                            fontSize: "18px",
                            width: "30%",
                          }}
                        >
                          {formValue.fieldName}
                        </p>
                        <p
                          style={{
                            width: "30%",
                          }}
                        >
                          {formValue.type}
                        </p>
                        <div
                          style={{
                            width: "30%",
                            display: "flex",
                            flexWrap: "wrap",
                            justifyContent: "flex-start",
                            flexDirection: "row",
                            gap: "20px",
                          }}
                        >
                          {formValue?.options?.map((option) => (
                            <div
                              style={{
                                width: "fit-content",
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "flex-start",
                                gap: "7px",
                              }}
                            >
                              <div
                                style={{
                                  width: "7px",
                                  height: "7px",
                                  borderRadius: "10px",
                                  background: "#2d4bf3",
                                }}
                              />
                              <p style={{ fontWeight: 500 }}>{option}</p>
                            </div>
                          ))}
                        </div>
                        <p onClick={() => handleDelete(formValue)}>
                          <FontAwesomeIcon
                            style={{ color: "red", cursor: "pointer" }}
                            icon={faTrash}
                          />
                        </p>
                      </div>
                    ))}
                  </div>
                )}

                <div
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    gap: "40px",
                  }}
                >
                  <input
                    style={{ marginBottom: 0 }}
                    type="text"
                    value={currentField}
                    placeholder="Field Name"
                    onChange={(e) => setCurrentField(e.target.value)}
                  />
                  <select
                    onChange={(e) => {
                      if (e.target.value === "Field Type") return;
                      setCurrentFieldType(e.target.value);
                    }}
                    value={currentFieldType}
                    className="form-control"
                    placeholder="Field type"
                  >
                    <option value="">Select Field Type</option>
                    <option>Text based answer</option>
                    <option>Options based answer</option>
                  </select>
                </div>
                {currentFieldType === "Options based answer" && (
                  <div
                    style={{
                      marginTop: "20px",
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      gap: "40px",
                    }}
                  >
                    <div
                      style={{
                        width: "50%",
                        display: "flex",
                        flexWrap: "wrap",
                        flexDirection: "row",
                        gap: "20px",
                      }}
                    >
                      {currentOptions.map((option) => (
                        <div
                          style={{
                            // width: "40px",
                            display: "flex",
                            flexDirection: "row",
                            alignItems: "center",
                            justifyContent: "center",
                            gap: "7px",
                          }}
                        >
                          <div
                            style={{
                              width: "7px",
                              height: "7px",
                              borderRadius: "10px",
                              background: "#2d4bf3",
                            }}
                          />
                          <p style={{ fontWeight: 500 }}>{option}</p>
                        </div>
                      ))}
                    </div>
                    <input
                      style={{
                        width: "50%",
                        marginBottom: 0,
                      }}
                      type="text"
                      value={currentOption}
                      placeholder="Option Name"
                      onChange={(e) => setCurrentOption(e.target.value)}
                      onKeyDown={(e) => {
                        if (e.key === "Enter") {
                          if (!currentOption) return;
                          setCurrentOptions((prev) => [...prev, currentOption]);
                          setCurrentOption("");
                        }
                      }}
                    />
                  </div>
                )}
              </div>
            </div>
            <button
              className="btn btn-success"
              onClick={(e) => {
                if (!currentField || !currentFieldType) return;
                if (
                  currentFieldType === "Options based answer" &&
                  !currentOptions?.length
                )
                  return;

                const formFields = [
                  ...report.form,
                  {
                    fieldName: currentField,
                    type: currentFieldType,
                    options: currentOptions,
                  },
                ];
                setReport({ ...report, form: formFields });
                setCurrentField("");
                setCurrentFieldType("");
                setCurrentOption("");
                setCurrentOptions([]);
              }}
              style={{
                display: "block",
                width: "200px",
                alignSelf: "flex-end",
              }}
            >
              Add field
            </button>
          </div>
          <button
            onClick={handleSubmit}
            className="btn btn-success btn-block"
            style={{ display: "block", marginTop: "80px" }}
          >
            Create patrol report
          </button>
        </div>
        <img src={SVGs.close} alt="" onClick={onClose} />
      </div>
    </div>
  );
};

const HandleSearchAndTab = styled.section`
  .container {
    margin-bottom: 20px;
  }
  .normal_tab {
    background: transparent;
  }
  .event-input {
    max-width: 675px;
  }
  @media (max-width: 420px) {
    .search_set,
    button {
      width: 100%;
      margin-bottom: 20px;
    }
  }
  @media (min-width: 760px) {
    display: flex;
    justify-content: space-between;
    .search_set {
      width: 220px;
    }
    .outlined {
      width: 180px !important;
    }
    .event-input {
      display: flex;
      justify-content: space-between;
      //   width: 57%;
      .select_me {
        margin: 0 10px;
        width: 135px;
      }
      button {
        margin-top: 0;
        height: 45px;
        margin-left: 10px;
      }
      .event-select {
        width: 20%;
      }
    }
  }
  @media (max-width: 540px) {
    .event-input {
      .event-select {
        display: none;
      }
    }
  }
  .tabs {
    margin: 0;
    margin-bottom: 30px;
    .tab {
      margin: 0;
      height: 45px;
      align-items: center;
      display: flex;
      justify-content: center;
      padding: 0;
      min-width: 100px;
      padding: 5px 20px;
      text-align: center;
      margin-right: 15px;
      border-bottom: 3px solid #c0c0c0;
      button {
        margin: 0;
        padding: 0 !important;
        padding: 10px;
        //styleName: Web/Small Copy;

        font-size: 16px;
        font-weight: 400;
        line-height: 17px;
        letter-spacing: 0em;
        text-align: left;
      }
    }
    .active {
      background: transparent;
      border-bottom: 3px solid #2d4bf3;
      button {
        color: #2d4bf3;
      }
    }
  }
  .normal_tab.add_tape {
    border-bottom: 2px solid yellow;
  }
`;
const UtilityGrid = styled.div`
  .team-members {
    margin-top: 40px;
  }

  .Utility_table {
    display: flex;
    flex-wrap: wrap;
  }
  .btn {
    display: flex;
  }
  .utils {
    margin-bottom: 10px;
    margin: 10px;
    padding: 16px;
    width: 100%;
    border: 1px solid #2d4bf3;
    border-radius: 5px;
    .name_tag {
      h4 {
        font-size: 18px;
        font-weight: 700;
        line-height: 24px;
        letter-spacing: 0em;
        text-align: left;
      }
      button {
        margin: 0;
        font-weight: 400;
        padding: 2px 8px;

        font-size: 14px;
        margin-top: 10px;
        background: #f2f6ff;
        border: 1px solid #2d4bf3;
        border-radius: 5px;
      }
    }
  }

  .reason {
    width: 128px;
    height: 24px;
    background: #f2f6ff;
    border: 1px solid #2d4bf3;
    border-radius: 5px;
    padding: 4px 8px;
  }
  .price {
    margin-top: 10px;
  }
  .util-acct {
    margin-top: 10px;
  }

  .util-btn {
    font-weight: 500;
    font-size: 16px;
    line-height: 16px;
    cursor: pointer;
    margin-right: 10px;
  }
  .del-btn {
    color: #ff6969;
  }
  .edit-btn {
    color: #2d4bf3;
  }
  @media (min-width: 540px) {
    .utils {
      width: 48%;
    }
  }
  @media (min-width: 1024px) {
    .utils {
      width: 33%;
    }
  }
  @media (min-width: 1200px) {
    .utils {
      width: 24%;
    }
  }
`;
